<div class="modal-container">
  @if (showCloseButton) {
    <div (click)="onClose()" style="display: flex; justify-content: end;">
      <p style="margin-right: 1rem; padding-top: 1rem; cursor: pointer">
        <img alt=""
          class="header-img"
          height="25"
          ngSrc="assets/scalableVectorGraphics/close.svg"
        width="25" /></p>
      </div>
    }
    <app-combo-echart
      (closeModal)="onClose()"
      (noDataEvent)="onShowCloseButton()"
      [activity]="serviceData.activity"
      [chartType]="serviceData.chartType"
      [currentZoom]="serviceData.currentZoom"
      [destroyChart]="destroyChart"
      [fullScreen]="serviceData.fullScreen"
      [getAllActivities]="serviceData.getAllActivities"
      [goal]="serviceData.goal"
      [healthPlan]="serviceData.healthPlan"
      [isDayView]="serviceData.isDayView"
      [isShowBars]="serviceData.isShowBars"
      [isShowLines]="serviceData.isShowLines"
      [isSingleBars]="serviceData.isSingleBars"
      [isStacked]="serviceData.isStacked"
      [isWeekView]="serviceData.isWeekView"
      [observationChartType]="serviceData.observationChartType"
      [seriesMinMax]="serviceData.seriesMinMax"
      [zoomFactor]="serviceData.zoomFactor">
    </app-combo-echart>
  </div>

